export default {
  name: "advantage-index",
  props: {
    name: {
      type: String,
      default: () => ""
    }
  }
};